import React, { useState, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { priceRegex } from "../helper/regex";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import { getcarType } from "../store/slices/carType";
import JoditEditor from "jodit-react";
import { posthourlyCarCharges } from "../store/slices/hourlyCarCharges";

const AddHourlyCharges = () => {
  const editor = useRef(null);
  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };
  const [vehicleErrors, setvehicleErrors] = useState([]);
  const [distance, setDistance] = useState();
  const [carList, setcarList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [duration, setDuration] = useState("");
  const [description, setDescription] = useState("");

  const [vehicle, setVehicle] = useState([
    {
      id: Date.now(),
      vehicle: "",
      price: "",
    },
  ]);

  const handleAddpackage = (e) => {
    e.preventDefault();

    setVehicle([
      ...vehicle,
      {
        id: Date.now(),
        vehicle: "",
        price: "",
      },
    ]);

    setvehicleErrors([
      ...vehicleErrors,
      {
        vehicle: "",
        price: "",
      },
    ]);
  };

  const handleRemovepackage = (id) => {
    const updatedvehicle = vehicle.filter((q) => q.id !== id);
    setVehicle(updatedvehicle);

    const updatedErrors = vehicleErrors.filter(
      (_, index) => vehicle[index].id !== id
    );
    setvehicleErrors(updatedErrors);
  };

  const handleInputChange = async (index, field, value) => {
    const updatedvehicle = [...vehicle];
    const updatedErrors = [...vehicleErrors];

    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        vehicle: "",
        price: "",
      };
    }

    if (field === "vehicle") {
      updatedvehicle[index][field] = value;
      updatedErrors[index].vehicle =
        value.trim() === "" ? "Please select a vehicle" : "";
    }

    if (field === "price") {
      var sanitizedPrice = value.replace(/\D/g, "").slice(0, 5);
      updatedvehicle[index][field] = sanitizedPrice;
      updatedErrors[index].price =
        sanitizedPrice === "" || !priceRegex.test(sanitizedPrice)
          ? "Please enter a valid price"
          : "";
    }

    setvehicleErrors([...updatedErrors]); // Ensure state updates
    setVehicle([...updatedvehicle]);
  };

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Enter Description",
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    []
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    if (name === "distance") {
      setDistance(value);
      validationErrors.distance =
        value.trim() === "" ? "Please select distance" : "";
    }

    if (name === "duration") {
      setDuration(value);
      validationErrors.duration =
        value.trim() === "" ? "Please select duration" : "";
    }

    if (name === "description") {
      setDescription(value);
      validationErrors.description =
        value.trim() === "" ? "Please enter description" : "";
    }
    setErrors(validationErrors);
  };

  const validateForm = () => {
    let newErrors = {};

    // Places Validation
    if (!distance || distance.trim() === "") {
      newErrors.distance = "Please select distance";
    }
    if (!description.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter valid description";
    }

    if (!duration) {
      newErrors.duration = "Please select duration";
    }

    // package Validation
    const vehicleErrors = vehicle.map((item) => ({
      vehicle: item.vehicle === "" ? "Please select vehicle" : "",
      price: item.price.trim() === "" ? "Please enter price" : "",
    }));
    setvehicleErrors(vehicleErrors);

    // Check for any package errors
    if (vehicleErrors.some((err) => err.vehicle || err.price)) {
      newErrors.tourIternary = "Please fix errors in the package section";
    }

    // Finally set all errors in the state
    setErrors(newErrors);

    const isValid =
      Object.keys(newErrors).length === 0 &&
      vehicleErrors.every((err) => !err.vehicle && !err.price);

    return isValid;
  };
  const addPackage = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      return;
    }

    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const item = {
      isActive: 1,
      duration,
      description,
      isApproved: 1,
      vehicle,
      isSpecial: 0,
      distance,
    };

    try {
      await dispatch(posthourlyCarCharges(item)).unwrap();
      alert("Price added successfully!");
      navigate("/admin/hourly-car-charges");
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  React.useEffect(() => {
    dispatch(getcarType())
      .unwrap()
      .then((data) => {
        setcarList(data?.carData || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Price</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/tour-package"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Airport Pickup Drop Price
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Price</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Duration<span className="text-danger">*</span>
                </label>
                <select
                  name="duration"
                  value={duration}
                  onChange={handleChange}
                  placeholder="Enter duration"
                  className={`form-control ${
                    errors.duration ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  <option value="4 Hours">4 Hours</option>
                  <option value="5 Hours">5 Hours</option>
                  <option value="8 Hours">8 Hours</option>
                  <option value="10 Hours">10 hours</option>
                  <option value="12 Hours">12 Hours</option>
                </select>
                {errors.duration && (
                  <div className="text-danger mt-2">{errors.duration}</div>
                )}
              </div>
              <div className="col-md-5">
                <label className="form-label">
                  Distance <span className="text-danger">*</span>
                </label>
                <select
                  name="distance"
                  value={distance}
                  onChange={handleChange}
                  placeholder="Enter distance"
                  className={`form-control ${
                    errors.distance ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  <option value="25-30 Km">25-30 Km</option>
                  <option value="30 Km">30 Km</option>
                  <option value="60 Km">60 Km</option>
                  <option value="80 Km">80 Km</option>
                  <option value="100 Km">100 Km</option>
                </select>

                {errors.distance && (
                  <div className="text-danger mt-2">{errors.distance}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  onChange={(newContent) => {
                    setDescription(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      description:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter description"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Price <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {vehicle.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddpackage}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemovepackage(item.id)}
                          disabled={vehicle.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label className="form-label">
                            Vehicle Name <span className="text-danger">*</span>
                          </label>
                          <select
                            name="vehicle"
                            value={item.vehicle}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "vehicle",
                                e.target.value
                              )
                            }
                            className={`form-control ${
                              vehicleErrors[index]?.vehicle ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select Vehicle</option>
                            {carList?.map((car) => (
                              <option key={car._id} value={car._id}>
                                {car.carName}
                              </option>
                            ))}
                          </select>
                          {vehicleErrors[index]?.vehicle && (
                            <span className="error-message">
                              {vehicleErrors[index]?.vehicle}
                            </span>
                          )}
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">
                            Price
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="priceperPerson"
                            value={item.price}
                            onChange={(e) =>
                              handleInputChange(index, "price", e.target.value)
                            }
                            className={`form-control ${
                              vehicleErrors[index]?.price ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Price"
                          />
                          {vehicleErrors[index]?.price && (
                            <div className="text-danger mt-2">
                              {vehicleErrors[index]?.price}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddHourlyCharges;
